import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const approvalColumns: GridColumnConfig[] = [
  // {
  //   title: 'Leave Type',
  //   field: 'leaveType',
  //   filter: 'text',
  //   searchable: true,
  // },
  {
    title: 'Employee',
    field: 'employeeName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Service Area',
    field: 'serviceArea',
    filter: 'text',
    searchable: true,
  },
  // {
  //   title: 'Description',
  //   field: 'description',
  //   filter: 'text',
  //   searchable: true,
  // },
  {
    title: 'Start Date',
    field: 'fromDate',
    filter: 'text',
  },
  {
    title: 'End Date',
    field: 'toDate',
    filter: 'text',
  },
  {
    title: 'Status',
    field: 'leaveStatus',
    filter: 'text',
    searchable: true,
  },
];
